import { useNavigate } from 'react-router-dom';

/**
 * Compatibility shim for react-router v5's `useHistory`.
 *
 * Lets legacy `.js` pages that do
 *   `const history = useHistory(); history.push('/foo');`
 * run unchanged under react-router v7, which only exposes `useNavigate`.
 */
export const useHistory = () => {
    const navigate = useNavigate();
    return {
        push: (to: string) => navigate(to),
        replace: (to: string) => navigate(to, { replace: true }),
        go: (n: number) => navigate(n),
        goBack: () => navigate(-1),
    };
};

export default useHistory;
